<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="9" stroke="var(--icon-color)" stroke-width="2" />
    <path
        d="M16 6C17.3132 6 18.6136 6.25866 19.8268 6.7612C21.0401 7.26375 22.1425 8.00035 23.0711 8.92893C23.9997 9.85752 24.7362 10.9599 25.2388 12.1732C25.7413 13.3864 26 14.6868 26 16C26 17.3132 25.7413 18.6136 25.2388 19.8268C24.7362 21.0401 23.9997 22.1425 23.0711 23.0711C22.1425 23.9997 21.0401 24.7362 19.8268 25.2388C18.6136 25.7413 17.3132 26 16 26L16 16V6Z"
        fill="var(--icon-color)" />
    <rect x="15" y="2" width="2" height="28" rx="1" fill="var(--icon-color)" />
</svg>

